/**
 * BANDE DE VISUELS — carousel mobile
 *
 * En dessous de 960px la grille du haut de page laisse place à un défilement
 * horizontal continu (voir hdp.scss, bloc CAROUSEL). Le mouvement lui même est
 * une animation CSS sur la piste : ce fichier ne fait que préparer le terrain.
 *
 * 1. il duplique les visuels jusqu'à ce qu'un cycle couvre au moins la largeur
 *    d'écran, sinon la piste se viderait avant la reprise de la boucle
 * 2. il pose deux cycles identiques bout à bout, pour que la translation d'un
 *    cycle retombe exactement sur le second et rende la reprise invisible
 * 3. il mesure ce cycle et en déduit la durée, pour que la vitesse reste la même
 *    qu'il y ait 1 ou 7 visuels, sur téléphone comme sur tablette
 *
 * Numéroté 14 pour passer AVANT 15_intro.js : les clones doivent exister dans le
 * DOM au moment où l'animation d'entrée collecte ses cibles, sinon ils
 * resteraient figés pendant que les originaux s'animent.
 */
jQuery(document).ready(function ($) {

    const VITESSE = 38                      // px par seconde, c'est le curseur du rythme
    const REQUETE = "(max-width: 959px)"    // doit rester aligné sur medium-screen dans hdp.scss

    const bande = document.querySelector(".bloc_hdp .bande_visuels")

    if (!bande)
        return

    const piste = bande.querySelector(".piste")

    if (!piste)
        return

    // seule source de vérité : les clones sont jetés et refaits à chaque construction
    const originaux = Array.prototype.slice.call(piste.children)

    if (!originaux.length)
        return

    const mq = window.matchMedia(REQUETE)
    const sobre = window.matchMedia("(prefers-reduced-motion: reduce)").matches

    /**
     * Sur iOS, l'apparition et le masquage de la barre d'adresse déclenchent un
     * resize à chaque scroll. Reconstruire à ce moment là ferait repartir
     * l'animation de zéro, à vue. Seul un vrai changement de largeur compte : la
     * hauteur de bande est en vh, qui ne bouge pas avec la barre.
     */
    let largeurRef = window.innerWidth
    let timer = null

    function demonter() {
        const clones = piste.querySelectorAll(".clone")

        for (let i = 0; i < clones.length; i++)
            clones[i].remove()

        bande.classList.remove("est_carousel")
        bande.style.removeProperty("--bande-cycle")
        bande.style.removeProperty("--bande-duree")
    }

    function monter() {
        demonter()

        // le marqueur sert à 15_intro.js, qui adapte sa sortie au scroll. La mise
        // en page du carousel, elle, est déjà portée par le media query en CSS.
        bande.classList.add("est_carousel")

        // animations réduites : la bande reste une rangée simple, parcourable au doigt
        if (sobre)
            return

        const large = bande.clientWidth

        // mesure après la bascule en carousel : la classe est posée, le layout est à jour
        const jeu = originaux.reduce(function (total, el) {
            const marge = parseFloat(window.getComputedStyle(el).marginRight) || 0
            return total + el.getBoundingClientRect().width + marge
        }, 0)

        if (!jeu || !large)
            return

        // un cycle doit couvrir l'écran, sinon un blanc apparaît avant la reprise
        const repetitions = Math.max(1, Math.ceil(large / jeu))
        const cycle = jeu * repetitions

        // on complète jusqu'à deux cycles : le premier est déjà à l'écran, le second le double
        const fragment = document.createDocumentFragment()

        for (let i = 0; i < repetitions * 2 - 1; i++) {
            originaux.forEach(function (el) {
                const clone = el.cloneNode(true)

                clone.classList.add("clone")
                clone.setAttribute("aria-hidden", "true")

                // GSAP a pu écrire sur l'original : le clone repart d'une ardoise propre
                clone.removeAttribute("style")

                const img = clone.querySelector("img")

                if (img)
                    img.removeAttribute("style")

                fragment.appendChild(clone)
            })
        }

        piste.appendChild(fragment)

        bande.style.setProperty("--bande-cycle", cycle + "px")
        bande.style.setProperty("--bande-duree", (cycle / VITESSE) + "s")
    }

    function appliquer() {
        if (mq.matches)
            monter()
        else
            demonter()
    }

    function planifier() {
        if (window.innerWidth === largeurRef)
            return

        largeurRef = window.innerWidth

        clearTimeout(timer)
        timer = setTimeout(appliquer, 200)
    }

    appliquer()

    window.addEventListener("resize", planifier)

    if (mq.addEventListener)
        mq.addEventListener("change", planifier)
    else if (mq.addListener)
        mq.addListener(planifier)

})
